module.exports = __webpack_public_path__ + "static/fonts/yule-icon-set.woff";


//////////////////
// WEBPACK FOOTER
// ./src/style/fonts/yule-icon-set.woff
// module id = 673
// module chunks = 0